"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypeConseillerTrads = void 0;
exports.ETypeConseillerTrads = {
    assurance: "Assurance",
    autre: "Autre",
    banque: "Banque",
    conseiller_en_investissement_financier: "Conseiller en investissement financier",
    courtier_en_assurance: "Courtier en assurance",
    groupement: "Groupement",
};
